import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';

import { history } from './store';

import WithNotifyAlert, { NotifyAlertProvider } from './containers/WithNotifyAlert';

// VIEW COMPONENTS:
import HomePage from './containers/HomePage';
import CounterPage from './containers/CounterPage';
import LoginAutomatedPage from './containers/LoginAutomatedPage';
import ManualAccessPage from './containers/ManualAccessPage';
import WithoutSubscriptionPage from './containers/WithoutSubscriptionPage';

const routes = (
  <ConnectedRouter history={history}>
      <Switch>
        <Route exact path="/" component={NotifyAlertProvider(WithNotifyAlert(HomePage))} />
        <Route exact path="/counter" component={CounterPage} />
        <Route exact path="/login" component={LoginAutomatedPage} />
        <Route exact path="/login/pin" component={ManualAccessPage} />
        <Route exact path="/login/without_subscription" component={WithoutSubscriptionPage} />
      </Switch>
  </ConnectedRouter>
);

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js